import { getVATLabel, isCompanyCustomer } from '@pages/Checkout/helpers/billing'
import { GetCustomerResourceResponse } from '@services/payments/useGetCustomerResource'
import { Paragraph, Spacer } from '@ui-kit'
import { FC, Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './Details.module.scss'

interface DetailsProps {
  customerResourceData: GetCustomerResourceResponse
  countryLabel: string
}

export const Details: FC<DetailsProps> = ({
  customerResourceData,
  countryLabel
}) => {
  const { t } = useTranslation()

  const {
    name,
    street,
    city,
    postal_code,
    country,
    tax_identifier,
    is_company
  } = customerResourceData

  const customerType = isCompanyCustomer(is_company)
    ? t('creditcardstep.form.company')
    : t('creditcardstep.form.individual')

  return (
    <Fragment>
      <Paragraph color='neutral-6'>
        {t('creditcardstep.form.customer')}
      </Paragraph>

      <Paragraph size={16}>{customerType}</Paragraph>

      <Spacer space={15} />

      <Paragraph color='neutral-6'>
        {t('creditcardstep.form.country')}
      </Paragraph>

      <Paragraph size={16}>{countryLabel}</Paragraph>

      <Spacer space={15} />

      {isCompanyCustomer(is_company) ? (
        <div className={styles['details__company-fields']}>
          <div>
            <Paragraph color='neutral-6'>
              {t('creditcardstep.form.companyname')}
            </Paragraph>

            <Paragraph size={16}>{name}</Paragraph>
          </div>

          {tax_identifier ? (
            <div>
              <Paragraph color='neutral-6'>{t(getVATLabel(country))}</Paragraph>

              <Paragraph size={16}>{tax_identifier}</Paragraph>
            </div>
          ) : null}
        </div>
      ) : (
        <div>
          <Paragraph color='neutral-6'>
            {t('creditcardstep.form.namesurname')}
          </Paragraph>

          <Paragraph size={16}>{name}</Paragraph>
        </div>
      )}

      <Spacer space={15} />

      <Paragraph color='neutral-6'>
        {t('creditcardstep.form.address')}
      </Paragraph>

      <Paragraph size={16}>{street}</Paragraph>

      <Spacer space={15} />

      <div className={styles['details__city-fields']}>
        <div>
          <Paragraph color='neutral-6'>
            {t('creditcardstep.form.postcode')}
          </Paragraph>

          <Paragraph size={16}>{postal_code}</Paragraph>
        </div>

        <div>
          <Paragraph color='neutral-6'>
            {t('creditcardstep.form.city')}
          </Paragraph>

          <Paragraph size={16}>{city}</Paragraph>
        </div>
      </div>
    </Fragment>
  )
}

Details.displayName = 'CheckoutPaymentBillingDetails'
